export default "__VITE_ASSET__CAm3t3BE__"